import { useTranslation } from "react-i18next";

const useTranslationSetup = () => {
  const { t, i18n } = useTranslation();
  const activeLanguage = i18n.language;

  const setLanguage = (lang) => {
    sessionStorage.setItem("app_language", lang);
    i18n.changeLanguage(lang);
  };

  return { t, activeLanguage, setLanguage };
};

export default useTranslationSetup;
